"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbySeatBadge;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbySeatBadgeModule = _interopRequireDefault(require("./LobbySeatBadge.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

var _assets = require("../../../../../../../assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HARDCORE_IMG = "".concat(_assets.ASSETS_INTERFACE, "/icons/hclive.gif");
var GM_IMG = "".concat(_assets.ASSETS_INTERFACE, "/icons/GM00.gif");

// TODO: i18n
// eslint-disable-next-line complexity
function LobbySeatBadge(_ref) {
  var character = _ref.character,
      _ref$isGamemaster = _ref.isGamemaster,
      isGamemaster = _ref$isGamemaster === void 0 ? false : _ref$isGamemaster,
      _onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbySeatBadgeModule.default.badge, character && _LobbySeatBadgeModule.default[character.characterClass.id], className)
  }, character && /*#__PURE__*/_react.default.createElement("a", {
    className: _LobbySeatBadgeModule.default.hiddenIconLink,
    onClick: function onClick() {
      if (_onClick) _onClick(character === null || character === void 0 ? void 0 : character.id);
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.NAME,
    className: _LobbySeatBadgeModule.default.nameBtn,
    onClick: function onClick() {
      if (_onClick) _onClick(character === null || character === void 0 ? void 0 : character.id);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.buttonContent
  }, character && /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.charName
  }, character.name), !character && "Create Character")), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.class
  }, character && character.characterClass.i18nName.en
  /* TODO: i18n */
  ), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.level
  }, character && character.level), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.hardcore
  }, character && character.isHardcore && /*#__PURE__*/_react.default.createElement("img", {
    src: HARDCORE_IMG,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbySeatBadgeModule.default.gm
  }, character && isGamemaster && /*#__PURE__*/_react.default.createElement("img", {
    src: GM_IMG,
    alt: ""
  })));
}